// path: src/utils/usernameBlocklist.js

export const USERNAME_BLOCKED_TERMS = [
  // General profanity
    "asshole",
    "bastard",
    "bitch",
    "bullshit",
    "crap",
    "cunt",
    "damn",
    "dick",
    "douche",
    "douchebag",
    "fuck",
    "fucker",
    "fucking",
    "motherfucker",
    "piss",
    "prick",
    "shit",
    "shithead",
    "slut",
    "twat",
    "whore",

  // Sexual / explicit
    "anal",
    "ballsack",
    "bdsm",
    "blowjob",
    "boner",
    "boob",
    "boobs",
    "clit",
    "cock",
    "cum",
    "cumming",
    "dildo",
    "ejaculate",
    "fap",
    "fetish",
    "genitals",
    "handjob",
    "hentai",
    "horny",
    "masturbate",
    "milf",
    "nipple",
    "nude",
    "nudes",
    "orgasm",
    "penis",
    "porn",
    "porno",
    "pornhub",
    "pussy",
    "rape",
    "rapist",
    "semen",
    "sex",
    "sexual",
    "sperm",
    "testicle",
    "vagina",
    "xxx",

  // Hate / extremist references
    "adolf",
    "aryan",
    "hitler",
    "kkk",
    "klan",
    "nazi",
    "neo-nazi",
    "neonazi",
    "swastika",
    "whitepower",
    "white-power",

  // Racist / derogatory terms and common variants
    "chink",
    "coon",
    "cracker",
    "gook",
    "gypsy",
    "jigaboo",
    "kike",
    "nigga",
    "nigger",
    "paki",
    "raghead",
    "redskin",
    "sandnigger",
    "spic",
    "towelhead",
    "wetback",

  // Anti-LGBTQ+ slurs / derogatory terms
    "dyke",
    "fag",
    "faggot",
    "tranny",

  // Ableist / derogatory
    "retard",
    "retarded",
    "spaz",

  // Violence / self-harm themed
    "behead",
    "murder",
    "murderer",
    "suicide",
    "terrorist",

  // Drugs
    "cocaine",
    "crackhead",
    "heroin",
    "meth",
    "methhead",

  // Common bypass-style spellings
    "a55",
    "b1tch",
    "biatch",
    "fuk",
    "fukk",
    "fuq",
    "phuck",
    "sh1t",
    "slvt",
    "wh0re",
];

export const normalizeUsernameForBlocklist = (value) => {
    return String(value || "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
};

export const isUsernameAllowed = (username) => {
    const normalizedUsername = normalizeUsernameForBlocklist(username);

    if (!normalizedUsername) {
    return false;
    }

    return !USERNAME_BLOCKED_TERMS.some((blockedTerm) => {
    const normalizedBlockedTerm = normalizeUsernameForBlocklist(blockedTerm);

    return (
        normalizedBlockedTerm &&
        normalizedUsername.includes(normalizedBlockedTerm)
    );
    });
};